import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Acknowledgments from './components/Acknowledgments';
import Projects from './components/Projects';
import Links from './components/Links';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Whitepapers from './pages/Whitepapers';
import WhitepaperDetail from './pages/WhitepaperDetail';
import './styles/whitepapers.css';


const App = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [route, setRoute] = useState(window.location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      setRoute(window.location.pathname);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    if (!window.location.hash) {
      return;
    }
    window.setTimeout(() => {
      const target = document.querySelector(window.location.hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  }, [route]);

  const handleNavigate = (path) => {
    if (!path) {
      return;
    }
    window.history.pushState({}, '', path);
    setRoute(window.location.pathname);
    if (window.location.hash) {
      window.setTimeout(() => {
        const target = document.querySelector(window.location.hash);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }, 0);
      return;
    }
    window.scrollTo(0, 0);
  };

  const isWhitepaperRoute = route.startsWith('/whitepapers');
  const slug = route.startsWith('/whitepapers/') ? route.split('/')[2] : null;

  let pageContent = null;
  if (route === '/whitepapers') {
    pageContent = <Whitepapers onNavigate={handleNavigate} />;
  } else if (route.startsWith('/whitepapers/')) {
    pageContent = <WhitepaperDetail slug={slug} onNavigate={handleNavigate} />;
  } else {
    pageContent = (
      <main>
        <Hero />
        <About />
        <Skills />
        <Acknowledgments />
        <Projects />
        <Links />
        <Contact />
      </main>
    );
  }

  return (
    <div
      className={
        isWhitepaperRoute
          ? 'min-h-screen text-slate-900 whitepaper-theme'
          : 'min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 text-gray-800 dark:text-gray-200'
      }
    >
      <Header isScrolled={isScrolled} currentPath={route} onNavigate={handleNavigate} />
      {pageContent}
      <Footer />
    </div>
  );
};

export default App;
